<template>
  <div class="container">
    <q-row
      :gutter="15"
    >
      <component
        :is="getLeftColumn"
        :categories="categories"
      />

      <component
        :is="getRightColumn"
        :categories="categories"
      />
    </q-row>
  </div>
</template>

<script>
  import categoriesAndSearchColumn from "./categoriesAndSearchColumn";
  import blogCardList from "./blogCardList";

  export default {
    name: "Blog",

    components: {
      'categories-search-column': categoriesAndSearchColumn,
      'blog-card-list': blogCardList
    },
    data() {
      return {
        categories: []
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize());
    },

    beforeRouteUpdate(to, from, next) {
      this.initialize();
      next(vm => vm.initialize());
    },
    computed: {
      isRtl() {
        return this.$qt('direction') === 'rtl';
      },
      getRightColumn() {
        return this.isRtl ? 'categories-search-column' : 'blog-card-list'
      },
      getLeftColumn() {
        return this.isRtl ? 'blog-card-list' : 'categories-search-column'
      }
    },

    methods: {
      initialize() {
        this.$delegate('edms', 'getCategoriesForBlogList', {
          archive: 'blog'
        }).then((res) => {
          this.categories = res.result.categories;
        }).catch(() => {
        });
      },
    }
  }

</script>

<style scoped>
</style>